module.exports = __webpack_public_path__ + "static/media/bg_worth.746ca653.png";